import { Form, Input, TextArea } from "@/components/Form"
import Button from "@/components/Button"
import AdminLayout from "@/components/Layout/Admin"
import { router } from "@inertiajs/react"
import { ReactNode } from "react"

const EditEmail = ({ email }) => {
  const { id } = email

  const handleSubmit = (email) => {
    router.put(`/admin/emails/${id}`, { email })
  }

  return (
    <Form defaultValues={email} onSubmit={handleSubmit}>
      <Input name="subject" />
      <TextArea name="body" rows={20} />
      <Button>Save</Button>
    </Form>
  )
}

EditEmail.layout = (page: ReactNode) => <AdminLayout children={page} />

export default EditEmail
